import { defineComponent as r, useSlots as c, computed as l, createElementBlock as f, openBlock as p, normalizeStyle as m, normalizeClass as v, renderSlot as g } from "vue";
import { tw as t } from "../../utils/tailwind.js";
const S = /* @__PURE__ */ r({
  name: "RevSkeleton",
  __name: "Skeleton",
  props: {
    height: { default: "" },
    shape: { default: "circle" },
    width: { default: "" }
  },
  setup(s) {
    const e = s, a = c(), o = l(
      () => a.default && typeof a.default < "u"
    ), i = l(
      () => typeof e.height == "string" && e.height !== ""
    ), n = l(
      () => typeof e.width == "string" && e.width !== ""
    ), d = l(() => [
      t`bg-static-default-mid block`,
      t`animate-pulse motion-reduce:animate-none`,
      {
        circle: t`rounded-full`,
        line: t`rounded-xs h-auto`,
        rectangle: t`rounded-lg h-full`
      }[e.shape],
      o.value && t`overflow-hidden whitespace-nowrap indent-[100%]`,
      o.value && !n.value && t`max-w-fit`,
      !o.value && !e.height && e.shape === "line" && t`min-h-16`
    ]), h = l(() => ({
      height: i.value ? e.height : void 0,
      width: n.value ? e.width : void 0
    }));
    return (u, w) => (p(), f("div", {
      class: v(d.value),
      "data-test": "skeleton",
      style: m(h.value)
    }, [
      g(u.$slots, "default")
    ], 6));
  }
});
export {
  S as default
};
